module.exports = __webpack_public_path__ + "media/src/components/CarInsurancePage/BuyReasonSection/compare-quote-14ba7e796fdf3e7804896cf06732c765.png";